import { render, staticRenderFns } from "./ClaimStatus.vue?vue&type=template&id=793aa1b8&"
import script from "./ClaimStatus.vue?vue&type=script&lang=js&"
export * from "./ClaimStatus.vue?vue&type=script&lang=js&"
import style0 from "./ClaimStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClaimStatus.vue"
export default component.exports